// import React from "react";
// import { Redirect } from "react-router-dom";
// import { renderRoutes } from 'react-router-config';
import FrameLayout from "layouts/FrameLayout";
import BasicLayout from "layouts/BasicLayout";
import BlankLayout from "layouts/BlankLayout";
import Login from "pages/Login";
import Home from "pages/Home";
import NoticeList from "pages/NoticeList";
import NoticeDetail from "pages/NoticeDetail";
import MessageList from "pages/MessageList";
import APIDocument from "pages/APIDocument";
import GuideDocument from "pages/GuideDocument";
import FAQDocument from "pages/FAQDocument";
import NoApp from "pages/NoApp";
import NotFound from "pages/NotFound";
import Overview from "pages/Overview";
import Subscribe from "pages/Subscribe";
import LogMonitor from "pages/LogMonitor";
import TrafficPermission from "pages/TrafficPermission";
import Scheme from "pages/Scheme";
import SchemeList from "pages/SchemeList";
import SchemeDetail from "pages/SchemeDetail";
import AppList from "pages/AppList";
import SolvePlan from "pages/SolvePlan";
import Paper from "pages/Paper";
import Apitest from "pages/Apitest";
import Search from 'pages/Search';
import EditPsd from 'pages/EditPsd';
// 组件中心
import ComponentHome from 'pages/ComponentHome';
import ComponentList from 'pages/ComponentList';
import ComponentDetails from 'pages/ComponentDetails';

const Unauthorized = () => {
  window.location.href = "/passport/login";
  return null;
};

const config = [
  {
    path: "/app",
    component: BlankLayout,
    // exact: true,
    breadcrumbName: "",
    routes: [
      {
        path: "/app/frame",
        component: FrameLayout,
        // exact: true,
        breadcrumbName: "",
        // permissions: 'user',
        unauthorized: Unauthorized,
        routes: [
          {
            path: "/app/frame/empty",
            exact: true,
            component: NoApp,
            breadcrumbName: "",
          },
          {
            path: "/app/frame/overview",
            exact: true,
            component: Overview,
            breadcrumbName: "应用总览",
          },
          {
            path: "/app/frame/subscribe",
            exact: true,
            component: Subscribe,
            breadcrumbName: "订阅管理",
          },
          {
            path: "/app/frame/trafficpermission",
            exact: true,
            component: TrafficPermission,
            breadcrumbName: "流量权限",
          },
          {
            path: "/app/frame/logmonitor",
            exact: true,
            component: LogMonitor,
            breadcrumbName: "日志监控",
          },
          {
            path: "/app/frame/scheme",
            // exact: true,
            component: Scheme,
            breadcrumbName: "对接方案",
          },
          {
            path: "/app/frame/schemedetail",
            exact: true,
            component: SchemeDetail,
            breadcrumbName: "对接方案",
          },
          {
            path: "/app/frame/schemelist",
            exact: true,
            component: SchemeList,
            breadcrumbName: "对接方案",
          },
        ],
      },
      {
        path: "/app/basic",
        // exact: true,
        component: BasicLayout,
        breadcrumbName: "",
        routes: [
          {
            path: "/app/basic/list",
            exact: true,
            component: AppList,
            breadcrumbName: "应用列表",
          },
        ],
      },
      {
        path: "/app/*",
        exact: true,
        component: NotFound,
        breadcrumbName: "",
      },
    ],
  },
  {
    path: "/notice",
    exact: true,
    component: NoticeList,
    breadcrumbName: "",
  },

  {
    path: "/notice/:noticeid",
    exact: true,
    component: NoticeDetail,
    breadcrumbName: "",
  },
  {
    path: "/message",
    exact: true,
    component: MessageList,
    breadcrumbName: "",
  },
  {
    path: "/solve",
    component: BlankLayout,
    routes: [
      {
        path: "/solve/:type",
        exact: true,
        component: SolvePlan,
      },
      
    ],
  },
  {
    path: "/search",
    component: Search,
  },
  {
    path: "/paper",
    exact: true,
    component: Paper,
  },
  {
    path: "/apitest",
    exact: true,
    component: Apitest,
  },
  {
    path: "/component",
    component: BlankLayout,
    breadcrumbName: "组件中心",
    routes: [
      {
        path: "/component/index",
        exact: true,
        component: ComponentHome,
        breadcrumbName: "组件中心首页"
      },
      {
        path: "/component/list",
        exact: true,
        component: ComponentList,
        breadcrumbName: "组件中心列表页"
      },
      {
        path: "/component/details",
        exact: true,
        component: ComponentDetails,
        breadcrumbName: "组件中心详情页"
      }
    ],
  },
  {
    path: "/doc",
    component: BlankLayout,
    breadcrumbName: "文档中心",
    routes: [
      {
        path: "/doc/api",
        exact: true,
        component: APIDocument,
        breadcrumbName: "API文档",
      },
      {
        path: "/doc/guide",
        exact: true,
        component: GuideDocument,
        breadcrumbName: "常用文档",
      },
      {
        path: "/doc/faq",
        exact: true,
        component: FAQDocument,
        breadcrumbName: "常见问题",
      },
    ],
  },
  {
    path: "/passport/login",
    exact: true,
    // component: () => <Redirect to="/home" />, // eslint-disable-line
    component: Login,
    breadcrumbName: "",
  },
  {
    path: "/passport/editpsd",
    exact: true,
    // component: () => <Redirect to="/home" />, // eslint-disable-line
    component: EditPsd,
    breadcrumbName: "",
  },
  {
    path: "/",
    exact: true,
    // component: () => <Redirect to="/home" />, // eslint-disable-line
    component: Home,
    breadcrumbName: "",
  },
  {
    path: "*",
    exact: true,
    component: NotFound,
    breadcrumbName: "",
  },
];

export default config;
